import visitorsClassicScenario from './visitors-classic';

/**
 * @param {object} server Mirage Server
 */
export default function (server) {
  const items = visitorsClassicScenario(server);
  const { locations, company } = items;

  const connectSubscription = server.create('subscription', 'asConnect', {
    company,
  });

  const workplaceSubscription = server.create('subscription', 'asWorkplaceStandard', {
    company,
  });

  items.propertyWithSuitesAndTenantsWithInvites = server.create(
    'zone',
    'asProperty',
    'withTenantsWithInvites',
    'withSuites',
    'withDeviceConfigStaticPages'
  );
  items.propertyWithSuitesAndTenants = server.create(
    'zone',
    'asProperty',
    'withSuites',
    'withTenants',
    'withDeviceConfigStaticPages'
  );
  items.propertyWithSuites = server.create('zone', 'asProperty', 'withSuites');

  const propertiesWithInternalTenants = [];

  server.createList('location', 3, 'withConfig');

  server.createList('location', 2, 'withConfig', {
    disabled: true,
  });

  let roles = server.createList('company-role', 1, { company }, 'asGlobalAdmin');
  roles = [...roles, ...server.createList('company-role', 3, { company }, 'asEmployee')];

  roles.forEach((role) => {
    const user = server.create('user', 'asEmployee');
    role.update({ user });
  });

  items.propertiesForLocations = new Map();

  locations.forEach((location) => {
    server.create('flow', 'asPropertyWalkUp', {
      location,
    });

    const user = server.create('user', 'asEmployee');

    const property = server.create(
      'zone',
      'asProperty',
      'withLogo',
      'withTenants',
      'withSuites',
      'withBlockList',
      'withDeviceConfigStaticPages',
      {
        name: location.address,
      }
    );
    items.propertiesForLocations.set(location.id, property);

    server.create('zone-role', 'asZoneSecurityAdmin', {
      zone: property,
      user,
    });

    const gymLocation = server.create('location', 'withConfig', {
      name: 'Gym',
      property,
    });

    server.create('tenant', 'asConnected', 'withSuites', 'withInvites', {
      property,
      location: gymLocation,
    });

    const lobbyLocation = server.create('location', 'withConfig', {
      name: 'Lobby',
      property,
    });

    server.create('tenant', 'asConnected', 'withSuites', {
      property,
      location: lobbyLocation,
    });

    location.update({
      property,
      name: `${location.name} First Floor`,
    });

    server.create('tenant', 'asConnected', 'withSuites', {
      property,
      location,
    });

    propertiesWithInternalTenants.push(property);
  });

  return { ...items, propertiesWithInternalTenants, connectSubscription, workplaceSubscription };
}
